export const getDefaultState = () => {
  return {
    views: [],
    selectedView: null,
    selectedViewId: null,
    activeTags: [],
  };
};
export const state = getDefaultState();
